import PageShell from "@/components/PageShell";

export default function About() {
  return (
    <PageShell title="Hakkımızda" subtitle="Coinbuy, Türkiye merkezli işletmelerin kripto ödemeleri kolayca kabul etmesini sağlayan bir ödeme altyapısıdır.">
      <div className="prose-none space-y-5 text-sm text-muted-foreground leading-relaxed max-w-2xl">
        <p>Coinbuy olarak amacımız, kripto para ödemelerini geleneksel ödeme sistemleri kadar basit ve güvenilir hale getirmek. İşletmeler ürünlerini Türk Lirası üzerinden fiyatlandırır, müşteriler diledikleri kripto para ile ödeme yapar.</p>
        <p>Gelişmiş ödeme algılama, otomatik kur hesaplama, güvenli cüzdan yönetimi ve kolay para çekme özellikleriyle, kripto ödeme sürecinin her adımını sizin için yönetiyoruz.</p>
        <p>Geliştirici dostu API'miz ve özelleştirilebilir checkout deneyimimizle, ister küçük bir işletme ister büyük bir platform olun, Coinbuy ihtiyaçlarınıza uyum sağlar.</p>
      </div>
      <div className="mt-10 grid grid-cols-3 gap-5">
        {[["5+", "Desteklenen Kripto"], ["%99.9", "Uptime Hedefi"], ["7/24", "Ödeme Takibi"]].map(([n, l]) => (
          <div key={l} className="rounded-2xl border border-border bg-card p-6 text-center">
            <p className="text-2xl sm:text-3xl font-extrabold tracking-tighter text-primary">{n}</p>
            <p className="mt-1 text-xs text-muted-foreground">{l}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
